import { gql } from '@apollo/client';

export const DELETE_STAY_INFORMATION_MUTATION = gql`
  mutation DeleteStayInformation($id: ID!) {
    deleteStayInformation(input: { where: { id: $id } }) {
      stayInformation {
        title
      }
    }
  }
`;
